import {Component, Input, OnChanges} from '@angular/core';
import {NgClass} from '@angular/common';
import {TranslocoModule} from '@jsverse/transloco';
import {DonneesZoneDashboard} from '../DonneesZoneDashboard';

//Composant de navigation rapide entre les zones du dashboard (n'affiche des boutons que s'il y a au moins 2 zones)
@Component (
{
	selector: 'val-dashboard-navigation',
	imports:
	[
		NgClass,
		TranslocoModule
	],
	templateUrl: './dashboard-navigation.component.html',
	styleUrl: './dashboard-navigation.component.scss'
})
export class DashboardNavigationComponent implements OnChanges
{
	//Création
	constructor ()
	{
		this.zones = [];
		this.zoneActive = '';
	}

	//Zones à afficher dans la navigation
	@Input ()
	public zones: DonneesZoneDashboard[];

	//Identifiant de la zone actuellement active
	public zoneActive: string;

	//Traite le changement des paramètres d'entrée
	public ngOnChanges () : void
	{
		if (!this.zones.some (zone => zone.id === this.zoneActive))
			this.zoneActive = this.zones[0]?.id ?? '';
	}

	//Fait défiler la page vers la zone identifiée et la marque comme active
	//  Paramètres
	//    idZone : Identifiant de la zone
	public ScrollVersZone (idZone: string) : void
	{
		this.zoneActive = idZone;

		const element = document.getElementById (idZone);

		if (element)
			element.scrollIntoView ({ behavior: 'smooth' });
	}
}
